import { Component } from 'react';
import axios from 'axios';
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Popover
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import UserMenu from './UserMenu';
import CircularProgress from "@mui/material/CircularProgress";
import NZ2026Home from './NZ2026Home'
import NZ2026SeatComparison from "./NZ2026SeatComparison"
import VotersDemographics from "./VotersDemographics"
import VotersSeats from "./VotersSeats"
import PolicyView from "./PolicyView"
import NZ2026Summary from "./NZ2026Summary"
import PolicySummary from "./PolicySummary"


const THEME_OPTIONS = [
  { value: 'NZ2026',     label: 'NZ 2026', parent: 'NZ2026', show:"yes" },
  { value: 'voters',  label: 'Voter Breakdown', parent: 'voters', show:"yes" },
  { value: 'policy', label: 'Policy', parent: 'policy', show:"yes" },
  { value: 'segments', label: 'Segments', parent: 'segments', show:"yes" },
  { value: 'NZ2026/home', label: 'Home', parent: 'NZ2026', show:"no"},
      { value: 'NZ2026/seatComparison', label: 'Vote Change', parent: 'NZ2026', show:"no" },
      { value: 'NZ2026/summary', label: 'Summary', parent: 'NZ2026', show:"no" },
  { value: 'NZ2026/home', label: 'Home', parent: 'NZ2026', show:"no"},
      { value: 'voters/demographics', label: 'Demographics', parent: 'voters', show:"no" },
      { value: 'voters/seats', label: 'Seats', parent: 'voters', show:"no" },
  { value: 'policy/scorecard', label: 'Scorecard', parent: 'policy', show:"no" },
  { value: 'policy/summary', label: 'Summary', parent: 'policy', show:"no" },
];

const ALLOWED = new Set(THEME_OPTIONS.map(o => o.value));


const subMenuOptions = {
    NZ2026: [
      { value: 'NZ2026/home', label: 'Home', parent: 'NZ2026'},
      { value: 'NZ2026/seatComparison', label: 'Vote Change', parent: 'NZ2026' },
      { value: 'NZ2026/summary', label: 'Summary', parent: 'NZ2026' },
    ],
    voters: [
      { value: 'voters/demographics', label: 'Demographics', parent: 'voters' },
      { value: 'voters/seats', label: 'Profiles', parent: 'voters' },
    ],
    policy: [
      { value: 'policy/scorecard', label: 'Scorecard', parent: 'policy' },
      { value: 'policy/summary', label: 'Summary', parent: 'policy' },
    ],
  };



export default class Home extends Component {
  constructor(props) {
    super(props);

    const initialTheme = "NZ2026/home"
  
    
    const sectiontitle = THEME_OPTIONS.find(t=> t.value === initialTheme).label

    this.state = {
      selectedSection: initialTheme,
      sectionTitle: sectiontitle,
      user: { email: '', name: '', company: '' },
      anchorEl: null,
      hoveredButton: null,
      constituencyMap :null,
      SA3Map:null,
      SA2Map:null,
      loading: true  // 👈 new flag

      

    };
  }


  componentDidMount() {
    
    this._onPopState = () => {
      const selectedSection = this.state.selectedSection;
      this.applyTheme(selectedSection);
    };
    window.addEventListener('popstate', this._onPopState);
      axios.get('/api/user-info/')
      .then((response) => {
        this.setState({ user: response.data }, () => {
          console.log("user", this.state.user);
        });
      })
      .catch((error) => {
        console.error('Error fetching user info:', error);
      });
      Promise.all([
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandConstituency.json").then(r => r.json()),
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandSA3.json").then(r => r.json()),
        fetch(process.env.PUBLIC_URL + "/NZ_maps/newZealandSA2.json").then(r => r.json())
        ]).then(([constituencyData, sa3Data, sa2Data

        ]) => {
        const makeGeo = (data) => ({
            type: "FeatureCollection",
            features: (data.features || []).map(f => ({
            ...f,
            properties: { ...f.properties }
            }))
        });

        this.setState({
            constituencyMap: makeGeo(constituencyData),
            SA3Map: makeGeo(sa3Data),
            SA2Map: makeGeo(sa2Data),
        loading: false   // 👈 maps are ready
        });
        });
      

    }
  
  componentWillUnmount() {
    window.removeEventListener('popstate', this._onPopState);
  };

   applyTheme = (theme) => {
    if (!ALLOWED.has(theme)) return;
    const sectiontitle = THEME_OPTIONS.find(t=> t.value === theme).label;

    this.setState({
      selectedSection: theme,
      sectionTitle: sectiontitle
    });
  };
    handleHover = (button, el) => {
    if (button) {
      this.setState({ hoveredButton: button, anchorEl: el });
    } else {
      // We only clear if the mouse leaves the Popover too
      this.setState({ hoveredButton: null, anchorEl: null });
    }
  };
  
  render() {

    const {
    //   isPanelOpen,
       selectedSection,
       loading,
       SA2Map,
       SA3Map,
       constituencyMap

    } = this.state;

       if (loading) {
      // 👇 loading screen
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress />
        </div>
      );
    }

    return (
        <>
      <Box sx={{ display: 'flex', height: '8vh'}}>
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'hidden',
            display: 'flex',
            width: '50%',
            flexDirection: 'column',
          })}
        >
         
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 1,
              borderBottom: '3px solid',
              borderColor: '#000000',
            }}
          >
            <img
              src={process.env.PUBLIC_URL + '/static/images/stack_logo.png'}
              alt="District Profiles"
              style={{ height: 50, objectFit: 'contain' }}
            />

          </Box>
        </Box>

        <Box
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor:theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'hidden',
            display: 'flex',
            width: '50%',
            flexDirection: 'row',
             alignItems: "flex-start"
          })}
        >
         

          <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%', px: 2 }}>
      <ToggleButtonGroup
  value={selectedSection}
  exclusive
  onChange={(_, newTheme) => { if (!newTheme) return; this.applyTheme(newTheme); }}
  sx={{
    display: 'flex',
    gap: 4,
    flexGrow: 1,
  }}
>
  {THEME_OPTIONS
    .filter((opt) => opt.show === "yes")
    .map((opt) => {
        const selectedOption = THEME_OPTIONS.find(opt => opt.value === selectedSection);
      const isParentSelected = opt.parent === selectedOption.parent;

      return (
        <ToggleButton
          key={opt.value}
          value={opt.value}
          onMouseEnter={(e) => {
            if (subMenuOptions[opt.value]) {
              this.handleHover(opt.value, e.currentTarget);
            }
          }}
          sx={{
            textTransform: 'none',
            fontWeight: 800,
            border: 'none',
            borderRadius: 2,
            justifyContent: 'flex-start',
            fontSize: '16px',
            flex: 1,
            px: 2,
            py: 1,
            borderBottom: isParentSelected ? '10px solid #000000' : '2px solid #e0e0e0',
            backgroundColor: 'transparent',
            color: 'text.primary',
          }}
        >
          {opt.label}
        </ToggleButton>
      );
    })}
</ToggleButtonGroup>


        {/* Submenu Popover */}
        <Popover
          open={Boolean(this.state.anchorEl) && Boolean(this.state.hoveredButton)}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          disableRestoreFocus
          onClose={() => this.handleHover(null, null)}
          width='100%'
          PaperProps={{
            onMouseEnter: () => {}, // do nothing, keep open
            onMouseLeave: () => this.handleHover(null, null),
          }}
           sx={{width:'100%'}}
        >
          <ToggleButtonGroup orientation="vertical" sx={{width:'100%'}}
       >
            {this.state.hoveredButton &&
              subMenuOptions[this.state.hoveredButton].map((opt) => (
                <ToggleButton key={opt.value} value={opt.value} onClick={(_, newTheme) => { if (!newTheme) return; this.applyTheme(newTheme); }}>
                  {opt.label}
                </ToggleButton>
              ))}
        </ToggleButtonGroup>
      </Popover>
    </Box>
       {/* <Box sx={{  alignItems: 'flex-end', width: '5%', py:2 }}>
      
            <UserMenu user={this.state.user} onLogout={this.handleLogout} />
            </Box> */}
            </Box>
      </Box>
      
      <Box sx={{ display: 'flex', height: '92vh'}}>
        {selectedSection === "NZ2026/home" ? (
            <NZ2026Home SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
            ) : selectedSection === "NZ2026/seatComparison" ? (
            <NZ2026SeatComparison SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
            ):selectedSection === "NZ2026/summary" ? (
            <NZ2026Summary SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
            ):selectedSection ==="voters/demographics" ?(
                
            <VotersDemographics SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
             ):selectedSection ==="voters/seats" ?(
                
            <VotersSeats SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
             ):selectedSection ==="policy/scorecard" ?(
                
            <PolicyView SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
             ):selectedSection ==="policy/summary" ?(
                
            <PolicySummary SA2Map={SA2Map} SA3Map={SA3Map} constituencyMap={constituencyMap} />
             ): null}

      </Box>
    </>
    );
  }

}